export const de = {
  // Meta tags
  'meta.landing.title': 'Kostenlose QR-Codes ohne Ablaufdatum | QR Tool',
  'meta.landing.description': 'Erstelle statische und dynamische QR-Codes kostenlos — kein Ablaufdatum, keine Werbung. Mit Scan-Statistiken für registrierte Nutzer.',
  'meta.builder.title': 'QR-Code erstellen | QR Tool',
  'meta.builder.description': 'Link, Text, WiFi, WhatsApp, vCard, Instagram — QR-Code erstellen und als SVG, PNG oder JPG herunterladen.',
  'meta.myCodes.title': 'Meine QR-Codes | QR Tool',
  'meta.myCodes.description': 'Verwalte deine dynamischen QR-Codes, ändere Ziel-URLs und sieh Scan-Statistiken.',
  'meta.login.title': 'Anmelden | QR Tool',
  'meta.login.description': 'Melde dich an oder registriere dich für kostenlose dynamische QR-Codes mit Scan-Tracking.',

  // Landing page
  'landing.hero.title': 'QR-Codes ohne Ablaufdatum',
  'landing.hero.subtitle': 'Statisch oder dynamisch — kostenlos, für immer, ohne Tricks.',
  'landing.hero.cta': 'QR-Code jetzt erstellen',
  'landing.static.title': 'Statischer QR-Code',
  'landing.static.desc': 'Die Ziel-URL ist direkt im QR-Code gespeichert. Kein Account, kein Server — funktioniert immer und überall.',
  'landing.static.feat1': 'Kein Account nötig',
  'landing.static.feat2': 'Kein Ablaufdatum',
  'landing.static.feat3': 'Funktioniert offline',
  'landing.static.feat4': 'URL nachträglich nicht änderbar',
  'landing.dynamic.title': 'Dynamischer QR-Code',
  'landing.dynamic.desc': 'Der QR-Code zeigt auf unseren Redirect-Server. Die Ziel-URL kannst du jederzeit ändern — ohne den QR-Code neu zu drucken.',
  'landing.dynamic.feat1': 'Ziel-URL jederzeit änderbar',
  'landing.dynamic.feat2': 'Scan-Statistiken (Land, Gerät, Browser)',
  'landing.dynamic.feat3': 'Kein Ablaufdatum',
  'landing.dynamic.feat4': 'Kostenloses Konto erforderlich',
  'landing.dynamic.cta': 'Kostenlos registrieren',
  'landing.types.title': 'Alle gängigen QR-Typen',
  'landing.types.subtitle': 'Link, Text, WiFi, WhatsApp, vCard, Instagram — und mehr.',
  'landing.notice.title': 'Keine Tricks. Kein Ablaufdatum.',
  'landing.notice.text': 'Dieses Tool ist Freeware. Wer den Entwickler unterstützen möchte, kann das gerne tun.',
  'landing.notice.cta': 'Entwickler unterstützen',

  // Auth
  'auth.login': 'Anmelden',
  'auth.register': 'Registrieren',
  'auth.logout': 'Abmelden',
  'auth.email': 'E-Mail',
  'auth.password': 'Passwort',
  'auth.username': 'Benutzername',
  'auth.confirmPassword': 'Passwort bestätigen',
  'auth.forgotPassword': 'Passwort vergessen?',
  'auth.resetPassword': 'Passwort zurücksetzen',
  'auth.resetPasswordDesc': 'Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen.',
  'auth.sendResetLink': 'Link senden',
  'auth.resetLinkSent': 'Ein Link zum Zurücksetzen wurde an {{email}} gesendet.',
  'auth.backToLogin': 'Zurück zum Login',
  'auth.noAccount': 'Noch kein Konto?',
  'auth.hasAccount': 'Bereits ein Konto?',
  'auth.usernameAvailable': 'Verfügbar',
  'auth.usernameTaken': 'Vergeben',
  'auth.usernameInvalid': 'Nur Buchstaben und Zahlen, max. 10 Zeichen',
  'auth.usernameChecking': 'Prüfe...',
  'auth.passwordMismatch': 'Passwörter stimmen nicht überein',
  'auth.loginWithGoogle': 'Mit Google anmelden',
  'auth.orDivider': 'oder',
  'auth.logoutMessage': 'Du wurdest abgemeldet.',

  // Account / Settings
  'account.title': 'Mein Konto',
  'account.profile': 'Profil',
  'account.changeEmail': 'E-Mail ändern',
  'account.changePassword': 'Passwort ändern',
  'account.changeAddress': 'Adresse ändern',
  'account.newEmail': 'Neue E-Mail',
  'account.currentPassword': 'Aktuelles Passwort',
  'account.newPassword': 'Neues Passwort',
  'account.confirmNewPassword': 'Neues Passwort bestätigen',
  'account.street': 'Straße',
  'account.zip': 'PLZ',
  'account.city': 'Stadt',
  'account.country': 'Land',
  'account.save': 'Speichern',
  'account.saved': 'Gespeichert!',
  'account.emailConfirmation': 'Eine Bestätigungs-E-Mail wurde an {{email}} gesendet.',
  'account.passwordChanged': 'Passwort erfolgreich geändert.',
  'account.memberSince': 'Mitglied seit {{date}}',

  // Home
  'home.welcome': 'Willkommen',
  'home.welcomeGuest': 'Willkommen, Gast',
  'home.description': 'Erstelle deinen QR-Code.',

  // QR Builder
  'qr.stepType': 'Typ wählen',
  'qr.stepContent': 'Inhalt eingeben',
  'qr.stepDesign': 'Design anpassen',
  'qr.typeLink': 'Link',
  'qr.typeText': 'Text',
  'qr.typeEmail': 'E-Mail',
  'qr.typeCall': 'Anruf',
  'qr.typeSms': 'SMS',
  'qr.typeVcard': 'V-Card',
  'qr.typeWhatsapp': 'WhatsApp',
  'qr.typeWifi': 'Wi-Fi',
  'qr.typeInstagram': 'Instagram',
  'qr.typePdf': 'PDF',
  'qr.typeApp': 'App',
  'qr.typeImages': 'Bilder',
  'qr.typeVideo': 'Video',
  'qr.typeSocial': 'Social Media',
  'qr.typeEvent': 'Event',
  'qr.typeBarcode': '2D Barcode',
  // Text form
  'qr.text.content': 'Text eingeben:',
  'qr.text.placeholder': 'Beliebiger Text...',

  // WiFi form
  'qr.wifi.networkName': 'Netzwerkname (SSID)',
  'qr.wifi.encryption': 'Verschlüsselung',
  'qr.wifi.password': 'Passwort',
  'qr.wifi.hidden': 'Verstecktes Netzwerk',
  'qr.wifi.encWpa': 'WPA/WPA2',
  'qr.wifi.encWep': 'WEP',
  'qr.wifi.encNone': 'Kein Passwort',

  // WhatsApp form
  'qr.wa.countryCode': 'Ländervorwahl',
  'qr.wa.phone': 'Telefonnummer',
  'qr.wa.message': 'Nachricht (optional)',

  // vCard form
  'qr.vcard.contactInfo': 'Kontaktinformationen',
  'qr.vcard.companyInfo': 'Unternehmensinformationen',
  'qr.vcard.location': 'Standort',
  'qr.vcard.firstName': 'Vorname',
  'qr.vcard.lastName': 'Nachname',
  'qr.vcard.phone': 'Telefon',
  'qr.vcard.mobile': 'Mobil',
  'qr.vcard.email': 'E-Mail',
  'qr.vcard.website': 'Webseite',
  'qr.vcard.company': 'Unternehmen',
  'qr.vcard.jobTitle': 'Position',
  'qr.vcard.fax': 'Fax',
  'qr.vcard.address': 'Adresse',
  'qr.vcard.city': 'Stadt',
  'qr.vcard.zip': 'PLZ',
  'qr.vcard.country': 'Land',

  // Instagram form
  'qr.insta.username': 'Instagram-Benutzername',

  'qr.scanUrl': 'Wird beim Scannen aufgerufen:',
  'qr.createShortLink': 'Kurzlink erstellen',
  'qr.enterUrl': 'Webseite eingeben:',
  'qr.urlPlaceholder': 'https://www.beispiel.de',
  'qr.generate': 'QR-Code erstellen',
  'qr.download': 'Herunterladen',
  'qr.designFrame': 'Rahmen',
  'qr.designShape': 'Form',
  'qr.designLogo': 'Logo',

  // Login page notice
  'login.noticeTitle': 'Keine Tricks. Kein Ablaufdatum.',
  'login.noticeText': 'Dieses Tool ist Freeware — keine nervige Werbung, keine automatische Deaktivierung deiner QR-Codes nach ein paar Tagen. Wer den Entwickler unterstützen möchte, kann das gerne tun.',
  'login.noticeCta': 'Entwickler unterstützen',

  // Navigation
  'nav.builder': 'QR-Code erstellen',

  // Footer
  'footer.impressum': 'Impressum',
  'footer.kontakt': 'Kontakt',
  'footer.datenschutz': 'Datenschutz',

  // My Codes
  'myCodes.title': 'Meine QR-Codes',
  'myCodes.empty': 'Noch keine QR-Codes erstellt.',
  'myCodes.scans': 'Scans',
  'myCodes.edit': 'Bearbeiten',
  'myCodes.delete': 'Löschen',
  'myCodes.confirmDelete': 'Sicher löschen?',
  'myCodes.titlePlaceholder': 'Titel (optional)',
  'myCodes.back': 'Zurück',

  // General
  'general.loading': 'Laden...',
  'general.error': 'Fehler',
  'general.success': 'Erfolg',
  'general.cancel': 'Abbrechen',
} as const
